import { makeStyles } from '@material-ui/core/styles';
import SendGiftBackground from 'assets/images/send-gift-background.png';

export const useStyles = makeStyles(theme => ({
  modalContainer: {
    maxWidth: theme.spacing(320),
    padding: theme.spacing(54.5, 24, 30),
    borderRadius: 28,
    background: `${theme.palette.common.white} url(${SendGiftBackground}) no-repeat top center / contain`,
  },
  modalTitle: {
    fontSize: 26,
    fontWeight: 700,
    lineHeight: '39px',
    color: '#144167',
    padding: theme.spacing(17.5, 0, 20.5),
    whiteSpace: 'break-spaces',
    textAlign: 'center'
  },
  planeIconContainer: {
    borderRadius: '50%',
    boxShadow: '0px 9px 15px #00000015',
    backgroundColor: theme.palette.common.white,
    height: theme.spacing(63),
    width: theme.spacing(63)
  },
  backToDashboardBtn: {
    boxShadow: '0px 3px 13px #C6E5FF',
    height: theme.spacing(28.5),
  },
}));
